import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { ISpecialProjectTradeControl } from '../interface/specialProject/ISpecialProjectTradeControl';

enum SpecialProjectTradeControlServiceEnum {
  base = "/",
}

export default class SpecialProjectTradeControlService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/special-project-control");
  }

  public getAll = async (): Promise<ISpecialProjectTradeControl[]> => await this.GET(SpecialProjectTradeControlServiceEnum.base);
  public getBySpecialProjectId = async (specialProjectId: number): Promise<ISpecialProjectTradeControl[]> => await this.GET(SpecialProjectTradeControlServiceEnum.base + specialProjectId);
}
